<template src="./SelectCustom.html"></template>

<script>
import { ref } from "vue";
import { onClickOutside } from '@vueuse/core'


export default {
  name: 'SelectCustom',
  props: {
    options: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    valueDefault: {
      type: String,
      required: false,
      default: () => ''
    },
    placeholder: {
      type: String,
      required: false,
      default: () => ''
    },
    required: {
      type: Boolean,
      required: false,
      default: () => false
    },
    errorText: {
      type: String,
      required: false,
      default: () => ''
    },
  },
  emits: ['action'],
  setup(props, {emit}) {
    const customSelectActive = ref('');
    const ariaExpandedBtn = ref(false);
    const modalRef = ref(null)

    const label_val = ref(props.label)
    const id_val = ref(props.id)
    const placeholder_val = ref(props.placeholder)
    const valueDefault_val = ref(props.valueDefault)
    const required_val = ref(props.required)
    const options_val = ref(props.options)

    function showOption() {
      customSelectActive.value = customSelectActive.value === '' ? 'active' : ''
      ariaExpandedBtn.value = !ariaExpandedBtn.value
    }

    onClickOutside(modalRef, () => {
          customSelectActive.value = ''
        },
    )

    function chooseOption(key) {
      customSelectActive.value = ''
      emit('action', key);
    }

    return {
      label_val,
      id_val,
      placeholder_val,
      valueDefault_val,
      required_val,
      options_val,
      customSelectActive,
      ariaExpandedBtn,
      modalRef,
      showOption,
      chooseOption
    }
  }
}
</script>

<style lang="scss">
.custom-select {
  position: relative;
  width: 200px;
  max-width: 100%;
  font-size: 1rem;
  color: #000;
}

.select-button {
  width: 100%;
  font-size: 1rem;
  background-color: #fff;
  padding: 0.3em 1em;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.selected-value {
  text-align: left;
}

.arrow {
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #000;
  transition: transform ease-in-out 0.3s;
}

.select-dropdown {
  position: absolute;
  list-style: none;
  width: 100%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 4px;
  padding: 5px 10px;
  margin-top: 5px;
  max-height: 200px;
  overflow-y: auto;
  transition: 0.5s ease;
  transform: scaleY(0);
  opacity: 0;
  visibility: hidden;
}

.select-dropdown:focus-within {
  box-shadow: 0 10px 25px rgba(94, 108, 233, 0.6);
}

.select-dropdown li {
  position: relative;
  cursor: pointer;
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 0 5px;
  margin: 5px 0;
}

.select-dropdown li label {
  width: 100%;
  padding: 8px 10px;
  cursor: pointer;
  display: flex;
  gap: 1rem;
  align-items: center;
}

.select-dropdown::-webkit-scrollbar {
  width: 7px;
}
.select-dropdown::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 25px;
}

.select-dropdown::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 25px;
}

.select-dropdown li:hover,
.select-dropdown input:checked ~ label {
  background-color: #f2f2f2;
}

.select-dropdown input:focus ~ label {
  background-color: #dfdfdf;
}

.select-dropdown input[type="radio"] {
  position: absolute;
  left: 0;
  opacity: 0;
}

/* interactivity */

.custom-select.active .arrow {
  transform: rotate(180deg);
}

.custom-select.active .select-dropdown {
  opacity: 1;
  visibility: visible;
  transform: scaleY(1);
}
</style>
